module.exports = __webpack_public_path__ + "static/media/icon-arrow-right.e8c86453.svg";